import InventoryControlDetailsComponent from './InventoryControlDetails';

const InventoryControlDetails = InventoryControlDetailsComponent;

export default InventoryControlDetails;
